/**
 * Memória do link de indicação no navegador do visitante.
 *
 * O first touch "de verdade" é no servidor, por pessoa (índice único por
 * identificador). Isto aqui cobre o caso de quem abriu o link do amigo, saiu
 * e voltou depois pelo endereço normal do cadastro (`/invite/:idPassbook`):
 * o código do primeiro link continua valendo por 30 dias. Não sobrescreve.
 */

export const FIRST_TOUCH_TTL_MS = 30 * 24 * 60 * 60 * 1000;
const KEY = (idPassbook: string) => `fixe:mgm:ref:${idPassbook}`;

interface Stored {
  code: string;
  at: number;
}

function read(storage: Storage | null, idPassbook: string): Stored | null {
  try {
    const raw = storage?.getItem(KEY(idPassbook));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Stored>;
    if (typeof parsed.code !== 'string' || typeof parsed.at !== 'number') return null;
    return { code: parsed.code, at: parsed.at };
  } catch {
    return null;
  }
}

/** Guarda o código se ainda não houver um válido. Devolve o que ficou valendo. */
export function rememberReferral(storage: Storage | null, idPassbook: string, code: string, now = Date.now()): string {
  const current = read(storage, idPassbook);
  if (current && now - current.at < FIRST_TOUCH_TTL_MS) return current.code;
  try {
    storage?.setItem(KEY(idPassbook), JSON.stringify({ code, at: now }));
  } catch {
    /* navegação privada / armazenamento bloqueado */
  }
  return code;
}

/** Código guardado e ainda válido, ou null. */
export function storedReferral(storage: Storage | null, idPassbook: string, now = Date.now()): string | null {
  const current = read(storage, idPassbook);
  return current && now - current.at < FIRST_TOUCH_TTL_MS ? current.code : null;
}

export function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
